import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import SiteFooter from '../shared/SiteFooter';
import SupportSection from './SupportSection';
import ResumeFormCallout from './ResumeFormCallout';
import { SUPPORT_EMAIL, supportSections } from './supportContent';
import '../legal/legal.css';
import './support.css';

// /support — issue/resolution reference content, styled from the same
// shell/tokens as the /privacy, /terms, /contact pages (legal.css) without
// reusing LegalPage.jsx directly, since this page needs collapsible rows
// and a jump-nav rather than flowing markdown prose.
const Support = () => {
  // Same auth state RequireAuth reads (components/auth/ProtectedApp.js) — no
  // new auth logic. `loading` is true only during the initial session
  // bootstrap in AuthProvider, so the back link is briefly omitted rather
  // than flashing "home" then swapping to "app" (or vice versa).
  const { session, loading } = useSelector((state) => state.auth);

  return (
    <div className="support-page">
      <nav className="legal-nav">
        <Link to="/" className="legal-nav-brand">
          <span className="legal-nav-logomark">Z</span>
          <span className="legal-nav-wordmark">ZYNACULAR</span>
        </Link>
        {!loading && (
          session ? (
            <Link to="/create" className="legal-nav-back">← Back to app</Link>
          ) : (
            <Link to="/" className="legal-nav-back">← Back to home</Link>
          )
        )}
      </nav>

      <main className="support-content">
        <div className="support-column">
          <h1 className="support-title">Support</h1>
          <p className="support-subtitle">
            Find answers below, or reach out — we're happy to help.
          </p>

          <nav className="support-jumpnav" aria-label="Support categories">
            {supportSections.map((s) => (
              <a key={s.id} href={`#${s.id}`}>{s.title}</a>
            ))}
          </nav>

          <ResumeFormCallout />

          {supportSections.map((s) => (
            <SupportSection
              key={s.id}
              id={s.id}
              title={s.title}
              description={s.description}
              rows={s.rows}
            />
          ))}

          <div className="support-help-block">
            <h2 className="support-help-title">Still need help?</h2>
            <p>
              Email us at <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>, or use
              the chat button in the corner to talk with us live.
            </p>
          </div>
        </div>
      </main>

      <SiteFooter />
    </div>
  );
};

export default Support;
